import { Component, Input, OnInit } from '@angular/core';
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { Router } from '@angular/router';
import { PopupStartFundraiserComponent } from '../popup-start-fundraiser/popup-start-fundraiser.component';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatButtonModule } from '@angular/material/button';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-start-fundraiser-button',
    templateUrl: './start-fundraiser-button.component.html',
    styleUrls: ['./start-fundraiser-button.component.scss'],
    standalone: true,
    imports: [NgIf, MatButtonModule, FlexModule, NgClass, ExtendedModule]
})
//** *Start Fundraiser Button Component */
export class StartFundraiserButtonComponent implements OnInit {
	@Input() buttonType = 'flat';
	@Input() themeColor = 'accent';
	dialog: MatDialog;
	isLoggedIn: boolean = false;

	constructor(
		public _dialog: MatDialog,
		public accountService: AccountService,
		public router: Router
	) {
		this.dialog = _dialog;
	}

	ngOnInit(): void {
		this.accountService.getLoginInformation().subscribe((data: Boolean) => {
			if (data == true) {
				this.isLoggedIn = true;
			} else {
				this.isLoggedIn = false;
			}
		});
	}

	//** *Open Share Popup*/
	startFundraiserPage(): void {
		this.router.navigate(['/start']);
	}
}
